const Slider = class Slider{
    
        constructor(){
        }
    
        /**
         *
         * @param slider
         * @param dots
         * @param arrows
         * @param speed
         */
        init(slider, dots = true, arrows = false, speed = 600){
            this.slider = $(slider);
            this.dots = dots;
            this.arrows = arrows;
            this.speed = speed;
    
            if($(this.slider).length){
                this.sliderConfig();
            }
        }
    
        /**
         *
         */
        sliderConfig(){
            let $slickElement = $('.js-slider-dots-arrow');
                
            $slickElement.on('init reInit afterChange', function (event, slick, currentSlide, nextSlide) {
                let pageLoadTl = new TimelineMax();
                
                pageLoadTl.fromTo($('.home__slide-text > div.right'), 0.6, {y: '-50px', autoAlpha: 0}, {
                    y: '0',
                    delay: 0,
                    autoAlpha: 1,
                    force3D: "auto",
                    ease: Power2.easeOut
                }, "start").fromTo($('.home__slide-text > div.left'), 0.6, {y: '50px', autoAlpha: 0},{
                    y: '0',
                    delay: 0,
                    autoAlpha: 1,
                    force3D: "auto",
                    ease: Power2.easeOut
                }, "start");              
            });

            var slidr = this.slider.slick({
                dots: this.dots,
                speed: 980,
                arrows: this.arrows,
                infinite: true,
                slidesToShow: 1,
                fade: true,
                cssEase: 'linear',
                nextArrow: this.arrows ? prevArrow : '',
                prevArrow: this.arrows ? nextArrow : ''
            }).on('beforeChange', function () {

                // $('.arrow').mouseenter(function(e) {
                //     $(this).trigger('click');
                //     $('[data-js="gallery-slider"]').slick("setOption", "autoplaySpeed", 10);
                // });

                // $('.arrow').mouseleave(function(e) {
                //     $('[data-js="gallery-slider"]').slick("setOption", "autoplaySpeed", 1600);
                // });

                let pageLoadTl = new TimelineMax();
                pageLoadTl.fromTo($('.home__slide-text > div.right'), 0.6, {y: '0', autoAlpha: 1}, {
                    y: '50px',
                    delay: 0,
                    autoAlpha: 0,
                    force3D: "auto",
                    ease: Power2.easeOut
                }, "start").fromTo($('.home__slide-text > div.left'), 0.6, {y: '0', autoAlpha: 1}, {
                    y: '-50px',
                    delay: 0,
                    autoAlpha: 0,
                    force3D: "auto",
                    ease: Power2.easeOut
                }, "start"); 
            });
        }
    /*
        _prevSlide(slick, nextSlide) {
            var $currentSlide = $(slick.$slider).find('.slick-slide').eq(nextSlide),
                image = $currentSlide.find('.product-slider__item-image'),
                text = $currentSlide.find('.product-slider__item-text'),
                box = $currentSlide.find('.product-slider__item-box'),
                arrow = box.find('.product-slider__arrow'),
                pageLoadTl = new TimelineMax();
    
            pageLoadTl.fromTo(text, 0.8, {x: '-120%', autoAlpha: 0}, {
                x: '0%',
                delay: 0.1,
                autoAlpha: 1,
                force3D: "auto",
                ease: Power2.easeOut
            }, "start").fromTo(box, 0.7, {x: '-178%', autoAlpha: 0}, {
                x: '0%',
                autoAlpha: 1,
                delay: 0.2,
                force3D: "auto",
                ease: Power2.easeOut
            }, "start").fromTo(image, 0.8, {x: '-138%', autoAlpha: 0}, {
                x: '0%',
                autoAlpha: 1,
                delay: 0.19,
                force3D: "auto",
                ease: Power2.easeOut
            }, "start").fromTo(arrow, 0.4, {autoAlpha: 0}, {
                autoAlpha: 1,
                delay: 0.6,
                force3D: "auto",
                ease: Power2.easeOut
            }, "start");
        }
    
        _nextSlide(slick, nextSlide) {
            var $currentSlide = $(slick.$slider).find('.slick-slide').eq(nextSlide),
                image = $currentSlide.find('.product-slider__item-image'),
                text = $currentSlide.find('.product-slider__item-text'),
                box = $currentSlide.find('.product-slider__item-box'),
                arrow = box.find('.product-slider__arrow'),
                pageLoadTl = new TimelineMax();
    
            pageLoadTl.fromTo(text, 0.8, {x: '120%', autoAlpha: 0}, {
                x: '0%',
                delay: 0.1,
                autoAlpha: 1,
                force3D: "auto",
                ease: Power2.easeOut
            }, "start").fromTo(box, 0.7, {x: '178%', autoAlpha: 0}, {
                x: '0%',
                autoAlpha: 1,
                delay: 0.2,
                force3D: "auto",
                ease: Power2.easeOut
            }, "start").fromTo(image, 0.8, {x: '138%', autoAlpha: 0}, {
                x: '0%',
                autoAlpha: 1,
                delay: 0.19,
                force3D: "auto",
                ease: Power2.easeOut
            }, "start").fromTo(arrow, 0.4, {autoAlpha: 0}, {
                autoAlpha: 1,
                delay: 0.6,
                force3D: "auto",
                ease: Power2.easeOut
            }, "start");
    
            // TweenMax.set('.product-slider__item-image', {
            //     clearProps: "all"
            // });
        }
        */
    };
    
    export {Slider};


// WEBPACK FOOTER //
// ./static/js/components/HomeSlider.js